<template>
  <div class="more-btn" @click="handleClick">{{ text }}</div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: '查看更多'
    }
  },
  methods: {
    handleClick() {
      this.$emit('handleClick')
    }
  }
}
</script>


<style scoped lang="scss">
.more-btn {
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 34px 34px 34px 34px;
  border: 1px solid #999999;
  text-align: center;
  color: #666666;
  cursor: pointer;
  margin: 0 auto;

  &:hover {
    background: linear-gradient(90deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
    border: 1px solid transparent;
  }
}
</style>
